import React, { ComponentProps } from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import { Flex, Text } from '@adsk/alloy-react-box';
import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';

import { useTranslation } from '../i18n';

type ReferenceActivityCardErrorProps = ComponentProps<typeof ActivityCard> & {
  onTryAgain?: (() => void) | null;
};

/**
 * This component shows indication that the reference picker activity card is in error state.
 */
const ReferenceActivityCardError = React.forwardRef<
  HTMLDivElement,
  ReferenceActivityCardErrorProps
>(({ onTryAgain, ...props }, ref) => {
  const { t } = useTranslation();
  return (
    <ActivityCard ref={ref} {...props}>
      <Flex alignItems="center">
        <AlertWarningIcon />
        <Text typography="bodySmall" color="charcoal700" marginLeft="8px">
          {t('ERROR_LOADING_ACTIVITY')}
        </Text>
        <LinkButton
          style={{ marginLeft: 8 }}
          onClick={() => onTryAgain?.()}
          size={LinkButton.SIZES.SMALL}
        >
          {t('TRY_AGAIN')}
        </LinkButton>
      </Flex>
    </ActivityCard>
  );
});

ReferenceActivityCardError.displayName = 'ReferenceActivityCardError';

export default ReferenceActivityCardError;
